"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Playable_1 = require("./Playable");
var YouTube_1 = require("./YouTube");
var Facebook_1 = require("./Facebook");
var Vimeo_1 = require("./Vimeo");
var Twitch_1 = require("./Twitch");
var DailyMotion_1 = require("./DailyMotion");
// @TODO enum ?
exports.playerVerifiers = {
    dailymotion: DailyMotion_1.verifier,
    facebook: Facebook_1.verifier,
    playable: Playable_1.verifier,
    twitch: Twitch_1.verifier,
    vimeo: Vimeo_1.verifier,
    youtube: YouTube_1.verifier,
};
exports.playerComponents = {
    dailymotion: DailyMotion_1.Player,
    facebook: Facebook_1.Player,
    playable: Playable_1.Player,
    twitch: Twitch_1.Player,
    vimeo: Vimeo_1.Player,
    youtube: YouTube_1.Player,
};
//# sourceMappingURL=index.js.map